import type { CustomIconProps } from '../types';

const Wishlist = ({ width, height, dataTestId }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '24'}
        height={height ?? '22'}
        viewBox="0 0 24 22"
        fill="none"
        data-testid={dataTestId}
    >
        <path
            stroke="#414042"
            fill="#FFF"
            d="M18.4.5c2.802 0 5.1 2.45 5.1 5.636 0 2.105-.59 3.863-2.355 6.147C19.4 14.541 16.532 17.28 12 21.328c-4.532-4.048-7.4-6.787-9.145-9.045C1.091 10 .5 8.241.5 6.136.5 2.95 2.798.5 5.6.5c2.22 0 3.559 1.258 4.668 2.578l.462.567.874 1.13.396.513.396-.513.873-1.13C14.479 2.145 15.863.5 18.4.5Z"
        />
    </svg>
);

export default Wishlist;
